import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterBodyDownloadAppsBlockConfig } from '@front-platform/content-builder';
import { bigFooterBodyDownloadAppsBlockResolveConfig } from '@front-platform/content-builder';
import { Capacitor } from '@capacitor/core';
import { Component, OnInit, input } from '@angular/core';
export interface BigFooterBodyDownloadAppsBlockRuntimeConfig {}

export type BigFooterBodyDownloadAppsBlockConfigInput = Partial<
  Omit<BigFooterBodyDownloadAppsBlockConfig, keyof BigFooterBodyDownloadAppsBlockRuntimeConfig> &
    BigFooterBodyDownloadAppsBlockRuntimeConfig
>;
export type BigFooterBodyDownloadAppsBlockResolvedConfig = Omit<
  BigFooterBodyDownloadAppsBlockConfig,
  keyof BigFooterBodyDownloadAppsBlockRuntimeConfig
> &
  Partial<BigFooterBodyDownloadAppsBlockRuntimeConfig>;
export interface BigFooterBodyDownloadAppsBlockContract extends ConfigComponentContract<
  BigFooterBodyDownloadAppsBlockConfigInput,
  BigFooterBodyDownloadAppsBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-body-download-apps-block',
  templateUrl: './big-footer-body-download-apps-block.component.html',
  standalone: false,
})
export class BigFooterBodyDownloadAppsBlockComponent
  implements OnInit, BigFooterBodyDownloadAppsBlockContract
{
  readonly config = input<BigFooterBodyDownloadAppsBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterBodyDownloadAppsBlockConfig,
    BigFooterBodyDownloadAppsBlockRuntimeConfig
  >(bigFooterBodyDownloadAppsBlockResolveConfig, () => ({ config: this.config() }));
  get heading(): string {
    return this.resolvedConfig()['heading'] as unknown as string;
  }
  get appStoreLink(): string {
    return this.resolvedConfig()['app_store_link'] as unknown as string;
  }
  get playStoreLink(): string {
    return this.resolvedConfig()['play_store_link'] as unknown as string;
  }

  isNative = false;

  constructor() {}

  ngOnInit(): void {
    this.isNative = Capacitor.isNativePlatform();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterBodyDownloadAppsBlockComponent, {
  'keyAliases': {},
});
